import { basePath, baseUrlWithBasePath } from '@/lib/constants';
import { convertStringToClassName } from '@/utils/convertStringToClassName';

export const generateCardLink = (
  cardTopic: string,
  cardLinkFromStoryblok: string
) => {
  const isCardLinkExternal = cardLinkFromStoryblok.startsWith('http');
  const cardTopicPath = `/${convertStringToClassName(cardTopic)}`;

  const cardLinkInternal = !isCardLinkExternal
    ? // ? `/invest${cardTopicPath}${cardLinkFromStoryblok}`
      `${basePath}${cardTopicPath}${cardLinkFromStoryblok}`
    : '';

  return isCardLinkExternal ? cardLinkFromStoryblok : cardLinkInternal;
};

export const generateCardLinkForSearch = (
  cardTopic: string,
  cardLinkFromStoryblok: string
) => {
  const isCardLinkExternal = cardLinkFromStoryblok.startsWith('http');
  const cardTopicPath = `/${convertStringToClassName(cardTopic)}`;

  const cardLinkInternal = !isCardLinkExternal
    ? // ? `https://invest.edb.gov.sg/${cardTopicPath}${cardLinkFromStoryblok}`
      `${baseUrlWithBasePath}${cardTopicPath}${cardLinkFromStoryblok}`
    : '';

  return isCardLinkExternal ? cardLinkFromStoryblok : cardLinkInternal;
};
